import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { GlobalDataStorage } from "./share/storages/global-data.storage";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from 'rxjs/operators';
import { Meta, Title } from '@angular/platform-browser';
declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'hk-b2b-iwaa-web';
  currentYear = '2026';

  constructor(
    translate: TranslateService,
    globalDataStorage: GlobalDataStorage,
    router: Router,
    private headTitle: Title,
    private meta: Meta
    ) {

    const navEndEvent$ = router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      gtag('config', 'UA-114640281-17', { 'page_path': e.urlAfterRedirects });
      var urlYear = e.urlAfterRedirects.substring(1,5);
      if (this.currentYear != urlYear){
        this.currentYear = urlYear;
        this.headTitle.setTitle('iFAST Wealth Advisers Awards ' + this.currentYear);
      }
    });

    translate.setDefaultLang(globalDataStorage.getStorage("locale") || "en");
    translate.use(globalDataStorage.getStorage("locale") || "en");
  }
}
